import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plane, Hotel, Palmtree, FileCheck, Car, Search } from "lucide-react";

const TABS = [
  { id: "flights", label: "Flights", icon: Plane, to: "/flights" },
  { id: "hotels", label: "Hotels", icon: Hotel, to: "/hotels" },
  { id: "packages", label: "Holiday Packages", icon: Palmtree, to: "/holidays" },
  { id: "visa", label: "Visa Assistance", icon: FileCheck, to: "/visa" },
  { id: "transfers", label: "Airport Transfers", icon: Car, to: "/transfers" },
];

export const BookingSearch = () => {
  const navigate = useNavigate();
  const [tab, setTab] = useState("flights");
  const [form, setForm] = useState({ destination: "", departure: "", ret: "", travellers: "2", budget: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const t = TABS.find((x) => x.id === tab);
    const params = new URLSearchParams();
    if (form.destination) params.set("destination", form.destination);
    if (form.departure) params.set("departure", form.departure);
    if (form.ret) params.set("return", form.ret);
    if (form.travellers) params.set("travellers", form.travellers);
    if (form.budget) params.set("budget", form.budget);
    navigate(`${t.to}?${params.toString()}`);
  };

  const inputCls = "w-full rounded-lg border border-[#E5E7EB] bg-[#F9FAFB] px-4 py-3 text-sm text-[#1F2937] placeholder:text-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#D4A62A] focus:border-transparent";

  return (
    <div className="relative z-20 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 -mt-24" data-testid="booking-search">
      <div className="bg-white rounded-2xl shadow-[0_28px_70px_rgba(10,46,77,0.16)] ring-1 ring-black/[0.03] border border-gray-100 overflow-hidden transition-shadow duration-300 hover:shadow-[0_32px_80px_rgba(10,46,77,0.2)]">
        <div className="flex overflow-x-auto mk-scrollbar border-b border-gray-100">
          {TABS.map((t) => (
            <button key={t.id} onClick={() => setTab(t.id)} data-testid={`search-tab-${t.id}`}
              className={`flex items-center justify-center gap-2 px-5 sm:px-7 py-4 md:flex-1 text-sm font-semibold whitespace-nowrap transition-colors duration-200 border-b-2 ${tab === t.id ? "border-[#D4A62A] text-[#0A2E4D] bg-[#FDF8EC]" : "border-transparent text-[#4B5563] hover:text-[#0A2E4D] hover:bg-[#FAFAF8]"}`}>
              <t.icon size={16} className={tab === t.id ? "text-[#D4A62A]" : ""} /> {t.label}
            </button>
          ))}
        </div>
        <form onSubmit={submit} className="p-6 sm:p-9 grid grid-cols-2 md:grid-cols-6 gap-5 items-end">
          <div className="col-span-2">
            <label className="text-xs font-semibold uppercase tracking-wider text-[#4B5563] mb-1.5 block">Destination</label>
            <input value={form.destination} onChange={set("destination")} placeholder="Where to? e.g. Dubai" className={inputCls} data-testid="search-destination-input" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#4B5563] mb-1.5 block">Departure</label>
            <input type="date" value={form.departure} onChange={set("departure")} className={inputCls} data-testid="search-departure-input" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#4B5563] mb-1.5 block">Return</label>
            <input type="date" value={form.ret} onChange={set("ret")} className={inputCls} data-testid="search-return-input" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-wider text-[#4B5563] mb-1.5 block">Travellers</label>
            <select value={form.travellers} onChange={set("travellers")} className={inputCls} data-testid="search-travellers-select">
              {[1,2,3,4,5,6,7,8].map((n) => <option key={n} value={n}>{n} {n === 1 ? "Traveller" : "Travellers"}</option>)}
            </select>
          </div>
          <div className="flex gap-3 col-span-2 md:col-span-1">
            <div className="flex-1 md:hidden">
              <label className="text-xs font-semibold uppercase tracking-wider text-[#4B5563] mb-1.5 block">Budget (USD)</label>
              <input value={form.budget} onChange={set("budget")} placeholder="Optional" className={inputCls} />
            </div>
            <button type="submit" className="mk-btn-gold w-full md:w-auto !px-6 h-[46px] self-end" data-testid="search-submit-btn">
              <Search size={16} /> Search
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
